"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configGetMultiLanguageFileRoutes = void 0;
const appConfig_1 = require("@/common/utils/appConfig");
const constants_1 = require("@/mock/mirage/constants");
const miragejs_1 = require("miragejs");
const configurations_1 = require("../../../data-manager/configurations");
function configGetMultiLanguageFileRoutes(server) {
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().multiLanguageSubUrl.en_us}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'login-2fa-otp-step-1': 'Step 1.'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().multiLanguageSubUrl.zh_cn}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'login-2fa-otp-step-1': '第 1 步。'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().multiLanguageSubUrl.zh_hk}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'login-2fa-otp-step-1': '步驟1'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().bannerMultiLanguageSubUrl.en_us}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'last-login': 'Last Login::'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().bannerMultiLanguageSubUrl.zh_cn}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'last-login': '上次登录时间：：'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().bannerMultiLanguageSubUrl.zh_hk}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'last-login': '上次登录时间：：'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().loginMultiLanguageSubUrl.en_us}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'organisation-id': 'Organisation I',
            'user-id': 'User I',
            password: constants_1.TEXT.PASSWORD1
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().loginMultiLanguageSubUrl.zh_cn}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'organisation-id': '公司I',
            'user-id': '用户I',
            password: constants_1.TEXT.PASSWORD2
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().loginMultiLanguageSubUrl.zh_hk}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            'organisation-id': '公司 ID',
            'user-id': '用户 ID',
            password: constants_1.TEXT.PASSWORD3
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().footerMultiLanguageSubUrl.en_us}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            label_1: '@ 2021 HDH.All Rights Reserved.'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().footerMultiLanguageSubUrl.zh_cn}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            label_1: '@ 2021 。保留所有权利。'
        });
    }, {
        timing: 2000
    });
    server.get(`${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${(0, appConfig_1.getConfig)().footerMultiLanguageSubUrl.zh_hk}`, (schema, request) => {
        console.log('request:', request);
        return new miragejs_1.Response(200, {}, {
            label_1: '@ 2021 。保留所有权利。'
        });
    }, {
        timing: 2000
    });
    return server;
}
exports.configGetMultiLanguageFileRoutes = configGetMultiLanguageFileRoutes;
exports.default = configGetMultiLanguageFileRoutes;
